import { defa }     from 'defa-object';
import ControlModel from 'scripts/poppet/control-model';

/**
 * defa.models.TemperatureConfiguration
 * The DEFA TemperatureConfiguration model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	zone: '/zone',
	tempConfig: '/deviceTemperatureConfiguration?attrs=',
};

const TemperatureConfiguration = ControlModel.extend( {
	
	url: function() { 
		return api.linkcom + this.get('unitId') + api.zone +
				this.get('zoneNumber') + api.tempConfig + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
	{
		currentTemperature: null,
		minTempExperienced: null,
		maxTempExperienced: null,
	}),
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	parse: function( response ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			this.set('currentTemperature', response.currentTemperature || null);
			this.set('minTempExperienced', response.minTempExperienced || null);
			this.set('maxTempExperienced', response.maxTempExperienced || null);
			this.receivedData( response );
		}
	},

	getAttributes: function() {
		return 'currentTemperature,minTempExperienced,maxTempExperienced';
	},
	
} );

export default TemperatureConfiguration;